import { ApplicationError } from "@closerplatform/spinner-openapi";

export const extractApplicationError = async (response: Response): Promise<ApplicationError> => {
    return await response.json() as ApplicationError;
};
